"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var queryStringParser_1 = require("../editableList/queryStringParser");
var App_1 = require("../../App");
var generic_1 = require("../generic");
var buttons_1 = require("../buttons");
var settings_1 = require("../editableList/settings");
var orderingList_1 = require("../editableList/orderingList");
var DataListToolbar = (function (_super) {
    __extends(DataListToolbar, _super);
    function DataListToolbar(props) {
        var _this = _super.call(this, props) || this;
        _this.onOrder = function () {
            _this.props.data_list.fetchData(window.location.search);
        };
        _this.onSaveSettings = function (values) {
            _this.props.data_list.settings.update(values).then(function () {
                _this.props.data_list.fetchData(window.location.search);
            });
        };
        _this.countFilters = function () {
            return _this.state.qs.get_key_count();
        };
        _this.applyHandler = function (event) {
            var paramString = _this.state.qs.toString();
            window.history.pushState(null, null, window.location.pathname + '?' + paramString);
            _this.props.data_list.fetchData("?" + paramString);
            jQuery('#' + _this.props.html_id + 'FilterCollapsible').removeClass('show');
        };
        _this.changeHandler = function (name, value) {
            var _a;
            var new_qs = _this.state.qs.clone();
            new_qs.reset_from_state(__assign(__assign({}, _this.state), (_a = {}, _a[name] = value, _a)));
            var newState = { 'qs': new_qs };
            newState[name] = value;
            _this.setState(newState);
        };
        var qs = new queryStringParser_1.QueryStringParser(window.location.search);
        _this.state = {
            qs: qs,
        };
        qs.get_names().forEach(function (field_name) {
            _this.state[field_name] = qs.get(field_name);
        });
        return _this;
    }
    DataListToolbar.prototype.render = function () {
        var _this = this;
        var context = App_1.store.context.get();
        var has_list_pref = this.props.has_list_pref !== undefined ? this.props.has_list_pref : true;
        var has_ordering_pref = this.props.has_ordering_pref !== undefined ? this.props.has_ordering_pref : true;
        var html_id = this.props.html_id;
        var FilterComponent = this.props.filter_component;
        var filter_counter = this.countFilters();
        return (React.createElement("div", { id: "listAccordion" },
            React.createElement("div", { className: "btn-toolbar justify-content-between mb-3", role: "toolbar", "aria-label": "Toolbar with button groups" },
                React.createElement("div", { className: "btn-group", id: "filters_group", role: "group", "aria-label": "Filter, List Settings and Ordering group" },
                    this.props.filter_component ?
                        React.createElement("button", { type: "button", className: "btn btn-link pl-0", id: "filter", "data-toggle": "collapse", "data-target": "#" + html_id + "FilterCollapsible", "aria-expanded": "false", "aria-controls": html_id + "FilterCollapsible" },
                            React.createElement(generic_1.Icon, { name: generic_1.Icons.filter }),
                            " ",
                            gettext("Filters"),
                            " ",
                            filter_counter > 0 && (React.createElement("span", { className: "badge badge-pill badge-primary" }, filter_counter))) : null,
                    has_list_pref ? React.createElement("button", { type: "button", className: "btn btn-link", id: "setting", "data-toggle": "collapse", "data-target": "#" + html_id + "SettingsCollapsible", "aria-expanded": "false", "aria-controls": html_id + "SettingsCollapsible" },
                        React.createElement(generic_1.Icon, { name: generic_1.Icons.cog }),
                        " ",
                        gettext("List settings")) : null,
                    has_ordering_pref ? React.createElement("button", { type: "button", className: "btn btn-link", id: "ordering", "data-toggle": "collapse", "data-target": "#" + html_id + "OrderingCollapsible", "aria-expanded": "false", "aria-controls": html_id + "OrderingCollapsible" },
                        React.createElement(generic_1.Icon, { name: generic_1.Icons.sorting }),
                        " ",
                        gettext("Ordering")) : null),
                React.createElement("div", { className: "btn-group", id: "list_actions_group", role: "group", "aria-label": "Actions group" },
                    this.props.bulk_edit_label &&
                        React.createElement(buttons_1.ActionButton, { onClick: function (event) {
                                $('#EditableList__BulkButtonId').click();
                            } },
                            React.createElement(generic_1.Icon, { name: generic_1.Icons.edit }),
                            " ",
                            this.props.bulk_edit_label),
                    this.props.quick_add_label &&
                        React.createElement(buttons_1.ActionButton, { onClick: function (event) {
                                $('#EditableList__QuickAddButtonId').click();
                            } },
                            React.createElement(generic_1.Icon, { name: generic_1.Icons.plus_circle }),
                            " ",
                            this.props.quick_add_label),
                    this.props.clickExportHandler &&
                        React.createElement(buttons_1.ActionButton, { onClick: function (event) { return _this.props.clickExportHandler.bind(_this)(event); } },
                            React.createElement(generic_1.Icon, { name: generic_1.Icons.file_excel }),
                            " ",
                            gettext("Export")))),
            this.props.filter_component ? React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-12" },
                    gettext("Number of rows in current filtering"),
                    ": ",
                    this.props.rows_counter)) : null,
            React.createElement("div", { className: "row toolbarCollapsible" },
                this.props.filter_component ? React.createElement("div", { className: "col-sm-12 col-md-4 collapse", id: html_id + "FilterCollapsible" },
                    React.createElement(FilterComponent, { filter_options: this.props.data_list.filter_state.data, qs: this.state.qs, changeHandler: this.changeHandler }),
                    React.createElement("div", { className: "mb-3" },
                        React.createElement("button", { className: "btn btn-primary btn-block", type: "button", onClick: this.applyHandler }, gettext("Apply")))) : null,
                has_list_pref ? React.createElement("div", { className: "col-sm-12 col-md-4 collapse", id: html_id + "SettingsCollapsible" },
                    React.createElement(settings_1.default, { settings: this.props.data_list.settings.data, save: this.onSaveSettings })) : null,
                has_ordering_pref ? React.createElement("div", { className: "col-sm-12 col-md-4 collapse", id: html_id + "OrderingCollapsible" },
                    React.createElement(orderingList_1.default, { ordering: this.props.data_list.data.ordering, onOrder: this.onOrder })) : null)));
    };
    DataListToolbar = __decorate([
        mobx_react_1.observer
    ], DataListToolbar);
    return DataListToolbar;
}(React.Component));
exports.default = DataListToolbar;
